import { LoadState } from "../../constants/enum";
import { IWaitList, IWaitListState } from "./waitlistTypes";



export const defaultWaitlistEntry: IWaitList = {
    waitlist_id: 0,
    waitlist_uuid: "",
    layout_uuid:"",
    layout_name:"",
    outlet_uuid: "",
    outlet_name: "",
    table_uuid: "",
    table_no: "",
    customer_fact_uuid: null,
    customer_mobile_no: "",
    customer_name: "",
    customer_email: "",
    number_of_guests: 0,
    priority: 0,
    waiting_time: 0,
    is_waiting_done: 0,
    current_waiting_count: 0,
    average_waiting_time: 0,
    notes: "",
    status: "",
    created_by_uuid: "",
    modified_by_uuid: "",
    create_ts: "",
    insert_ts: "",
    waiting_from: 0,
  };
  
  export const defaultWaitlistState: IWaitListState = {
    waitList: {
      loading: LoadState.idle,
      data: [],
      totalRecords: 0,
      error: null,
    },
    singleWaitList: {
      loading: LoadState.idle,
      data: defaultWaitlistEntry,
      error: null,
    },
  };